// TODO: Make this work.
// import breakpoints from '@/styles/tokens/_breakpoints.scss';
export const breakpoints = {
    sm: 0,
    md: 768,
};
export function currentBreakpoint() {
    const width = window.innerWidth;
    return width >= breakpoints.md ? 'md' : 'sm';
}
